import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function VideoIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M1 3V21H23V3H1ZM21 19H3V5H21V19ZM8 6.45117V17.5488L17.1553 12L8 6.45117ZM10 10.002L13.2969 12L10 13.998V10.002V10.002Z",
    fill: "currentColor"
  }));
}